<template>
  <div class="ecahrts" :style="{width:'100%',height:height}"></div>
</template>

<script>
export default {
  name: "Echarts",
  data() {
    return {}
  },
  watch: {
    option(opt) {
      this._setOption(opt)
    }
  },
  props: ['option', 'height'],
  components: {},
  methods: {
    _setOption(option) {
      const myChart = echarts.init(this.$el)
      myChart.setOption(option)
    }
  },
  computed: {},
  mounted() {
  }
}
</script>
